module.exports = __webpack_public_path__ + "img/a21.9ba1efaa.svg";